import React from "react";
import moment from "moment";
import UserDetailTable from "./userDtaileTable.compoment";

var UseDetail = function UseDetail(props) {
  var selectedUser = props.selectedUser,
      prefix = props.prefix,
      translate = props.translate;
  var solution = selectedUser.solution,
      sfxRole = selectedUser.sfxRole,
      FirstName = selectedUser.FirstName,
      LastName = selectedUser.LastName,
      userName = selectedUser.userName,
      AvatarUrl = selectedUser.AvatarUrl,
      LastAccessSolution = selectedUser.LastAccessSolution,
      LastAccessTime = selectedUser.LastAccessTime;
  var formatLastAccess = LastAccessTime ? moment.utc(LastAccessTime).local().format("YYYY-MM-DD h:mm:ss A") : "never";
  var formatSfxRole = Array.isArray(sfxRole) && sfxRole.length > 0 ? sfxRole.map(function (item) {
    return item.name;
  }).join(", ") : "--";
  var avatarFirstName = FirstName && FirstName.substring(0, 1) && FirstName.substring(0, 1).toUpperCase() || "";
  var avatarLastName = LastName && LastName.substring(0, 1) && LastName.substring(0, 1).toUpperCase() || "";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-user-detail-wrap")
  }, /*#__PURE__*/React.createElement("figure", null, AvatarUrl ? /*#__PURE__*/React.createElement("img", {
    className: "".concat(prefix, "-user-img"),
    src: AvatarUrl,
    alt: "photo"
  }) : /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-user-img")
  }, avatarFirstName, avatarLastName), /*#__PURE__*/React.createElement("figcaption", null, /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix, "-user-email")
  }, FirstName, " ", LastName), /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix, "-user-info")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-user-label")
  }, translate('SFxAccountSettingsUserEmailLabel')), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-user-value")
  }, userName)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-user-info")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-user-label")
  }, translate('SFxAccountSettingsUserSFxRoleLabel')), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-user-value"),
    title: formatSfxRole
  }, formatSfxRole)), /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix, "-user-info")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-user-label")
  }, translate('SFxAccountSettingsUserLastAccessLabel')), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-user-value")
  }, LastAccessSolution || "--")), /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix, "-user-info")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-user-label")
  }, translate('SFxAccountSettingsUserLastActiveLabel')), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-user-value")
  }, formatLastAccess)))), /*#__PURE__*/React.createElement(UserDetailTable, {
    solution: solution,
    prefix: prefix,
    translate: translate
  })));
};

export default UseDetail;